import React, { createContext, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { NavigationContextProps } from './types/navigation-context-props';
import { NavigationService } from '../../services/navigation/navigation-service';

export const NavigationContext = createContext<NavigationContextProps>(null!);

export function NavigationProvider(props: React.PropsWithChildren<unknown>) {
    const navigationService = new NavigationService();
    const history = useHistory();

    const push = (pathname: string, search?: string, state?: unknown) => {
        history.push({
            pathname: pathname,
            search: navigationService.addImpersonationToSearch(search),
            state: state
          });
    }

    const context = {
        push: push,
        getLocationIdUrlParam: (): number | null  => {
            return navigationService.getLocationId();
        },
        getCustomerIdUrlParam: (): number | null => {
            return navigationService.getCustomerId();
        }
    } as NavigationContextProps;

    return <NavigationContext.Provider value={{ ...context }}>{props.children}</NavigationContext.Provider>;
}

export function useNavigation() {
    const context = useContext(NavigationContext);

    if (!context) {
        throw new Error('useNavigation must be used within the NavigationProvider');
    }

    return context;
}
